import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Text,
  VStack,
  Spinner,
  Alert,
  AlertIcon,
  Grid,
  GridItem,
  Heading,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Input,
  useClipboard,
  HStack,
} from "@chakra-ui/react";

import ClassStudentsList from "./ClassStudent";
import { FaUser, FaUserShield, FaPlus, FaSync, FaPrint } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const ClassList = () => {
  const navigate = useNavigate();
  const [classDetails, setClassDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [meetLink, setMeetLink] = useState("");
  const [creatingMeet, setCreatingMeet] = useState(false);
  // const [showLink, setShowLink] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { hasCopied, onCopy } = useClipboard(meetLink);

  useEffect(() => {
    const fetchClassDetails = async () => {
      try {
        const staff_id = sessionStorage.getItem("staff_id");
        // alert(staff_id);
        if (!staff_id) {
          setError("No user ID found.");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `${BASE_URL}/staff/class/class_details.php?staff_id=${staff_id}`,
          { headers: { "Content-Type": "application/json" } }
        );
        console.log("class profile", response);

        if (response.data.success) {
          setClassDetails(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        console.error("API call error:", err);
        setError("An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchClassDetails();
  }, []);

  if (loading) {
    return (
      <Box textAlign="center" py={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={5}>
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  const handleClick = () => {
    navigate("/students/create");
  };

  // create meet handler

  const handleCreateMeet = async () => {
    setCreatingMeet(true);
    try {
      const res = await fetch("http://localhost:5000/api/create-meet");
      const data = await res.json();
      if (data.meetLink) {
        setMeetLink(data.meetLink);
      }
      console.log("create meet link:", data.meetLink);
    } catch (err) {
      console.error("Error creating meet:", err);
    } finally {
      setCreatingMeet(false);
    }
  };

  if (loading) {
    return (
      <Box textAlign="center" py={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  return (
    <Box width="100%">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 fontSize="20px">Class Details</h1>
            <div className="action-buttons">
              <Button
                className="refresh-button"
                boxShadow="md" // Applies a medium shadow
                backgroundColor="white"
                fontSize="11px"
                onClick={() => {
                  // Add refresh functionality here
                  console.log("Refresh button clicked");
                }}
                display={{ base: "none", md: "flex" }}
              >
                <FaSync color="#515B73" />
              </Button>

              <div className="export-dropdown">
                <Button
                  className="export-button"
                  display={{ base: "none", md: "flex" }}
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>
              </div>
              <Button
                colorScheme="teal"
                leftIcon={<FaPlus />}
                onClick={handleClick}
                mb={4}
              >
                <Box display={{ base: "none", md: "block" }}>Add Student</Box>
              </Button>
              {/* if meetLink exists show "View", else show "Create" */}
              {meetLink ? (
                <Button colorScheme="blue" onClick={onOpen} mb={4}>
                  View Meet
                </Button>
              ) : (
                <Button
                  colorScheme="teal"
                  leftIcon={<FaPlus />}
                  onClick={handleCreateMeet}
                  mb={4}
                  isLoading={creatingMeet}
                >
                  Create Meet
                </Button>
              )}
            </div>
          </div>

          <div className="breadcrumb">
            <span>Staff</span> / <span>Class</span>
          </div>
        </div>
        <Box p={6}>
          <Grid
            templateColumns={{
              base: "1fr", // Single column on mobile
              md: "repeat(1, 1fr)", // Two columns on tablets and small laptops
              lg: "repeat(1, 1fr)", // Three columns on larger screens
            }}
            gap={6}
            pb={6}
          >
            {classDetails.length > 0 ? (
              classDetails.map((detail) => (
                <GridItem
                  key={detail.id}
                  bg="white"
                  p={5}
                  shadow="md"
                  borderRadius="md"
                >
                  <Flex
                    direction={{
                      base: "column", // Stack elements vertically on mobile
                      md: "row", // Align elements horizontally on larger screens
                    }}
                    align="center"
                    justify="space-between"
                  >
                    <Text fontWeight="bold">Class: {detail.class}</Text>
                    <Text>Division: {detail.division}</Text>
                    <Text>Section: {detail.section}</Text>
                    <Text>
                      Class Leader: {detail.class_leader_name || "N/A"}
                    </Text>
                    <Text>Class Teacher: {detail.staff_name}</Text>
                  </Flex>
                </GridItem>
              ))
            ) : (
              <Text>No class details available.</Text>
            )}
          </Grid>
          {/* {meetLink && (
            <Box mt={4}>
              <Text fontWeight="bold">Meet link:</Text>
              <a href={meetLink} target="_blank" rel="noreferrer">
                {meetLink}
              </a>
            </Box>
          )} */}

          <ClassStudentsList />
        </Box>
      </div>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
        <ModalOverlay />
        <ModalContent borderRadius="lg" shadow="xl">
          {/* <ModalHeader textAlign="center" fontSize="xl" fontWeight="bold">
            Online Class Link
          </ModalHeader> */}
          <ModalCloseButton />

          <ModalBody textAlign="center" pb={6} pt={10}>
            <Text mb={2} fontSize="lg" fontWeight="semibold" color="teal.600">
              Your Google Meet is ready 🎉
            </Text>
            <Text fontSize="sm" color="gray.600" mb={5}>
              Share this link with your students to start the class.
            </Text>

            <HStack spacing={3} justify="center">
              <Input
                value={meetLink}
                isReadOnly
                size="sm"
                variant="filled"
                width="80%"
                borderRadius="md"
                fontSize="sm"
              />
              <Button size="sm" colorScheme="teal" onClick={onCopy}>
                {hasCopied ? " Copied!" : "Copy"}
              </Button>
            </HStack>
          </ModalBody>

          <ModalFooter justifyContent="center" gap={3}>
            {/* <Button bg="gray" onClick={onClose}>
              Close
            </Button> */}
            <Button as="a" href={meetLink} target="_blank" colorScheme="blue">
              Open Meet
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ClassList;
